<h4 class="card-title mb-3 main-title">{{ "PatientRecord.steps.history" | translate }}</h4>

<h5 class="mb-3 sub-title">{{ "PatientRecord.steps.fillInHistory" | translate }}</h5>

<app-medical-record [showCategories]="['family_history', 'social_history']"></app-medical-record>
